module.exports = __webpack_public_path__ + "img/mpcode.7b680032.jpeg";